/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, count: NonNullable<unknown> }} Spaces_Confirm_Delete_Folder_DescriptionInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to delete the folder \"{name}\" and all {count} files inside? This action cannot be undone." |
*
* @param {Spaces_Confirm_Delete_Folder_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_confirm_delete_folder_description = /** @type {((inputs: Spaces_Confirm_Delete_Folder_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Confirm_Delete_Folder_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Möchten Sie den Ordner "${i?.name}" und alle ${i?.count} Dateien darin wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.`)
	return /** @type {LocalizedString} */ (`Are you sure you want to delete the folder "${i?.name}" and all ${i?.count} files inside? This action cannot be undone.`)
});